import { render } from "./VrNebulous.vue?vue&type=template&id=3b8e7cd8&ts=true"
import script from "./VrNebulous.vue?vue&type=script&lang=ts"
export * from "./VrNebulous.vue?vue&type=script&lang=ts"

import "./VrNebulous.vue?vue&type=style&index=0&id=3b8e7cd8&lang=css"

import exportComponent from "D:\\Meta\\Metamorph\\Room\\Test\\nebulous\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__